import React from 'react';
import { Dialog } from '@/components/ui/Modal/Modal';
import { Alert } from '@/components/ui/Alert/Alert';

interface DisconnectCventDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  rfpName: string;
  loading?: boolean;
}

/**
 * Disconnect from Cvent Confirmation Dialog
 * 
 * Warns users about the consequences of disconnecting from a Cvent RFP
 */
export function DisconnectCventDialog({
  isOpen,
  onClose,
  onConfirm,
  rfpName,
  loading = false,
}: DisconnectCventDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Disconnect from Cvent?"
      description={
        <>
          You are about to disconnect from:
          <br />
          <span className="font-semibold">{rfpName}</span>
        </>
      }
      confirmText="Disconnect"
      cancelText="Cancel"
      confirmVariant="danger"
      isLoading={loading}
      size="sm"
      closeOnOverlayClick={!loading}
      closeOnEscape={!loading}
    >
      <Alert variant="warning">
        <div className="space-y-2">
          <p className="text-sm font-medium text-warning-900">
            This action will:
          </p>
          <ul className="text-sm text-warning-800 space-y-1 list-disc list-inside">
            <li>Remove the RFP connection from this event</li>
            <li>Remove all venue-to-Cvent supplier connections</li>
            <li>Clear all Cvent match data and confidence scores</li>
          </ul>
          <p className="text-sm font-medium text-warning-900 mt-2">
            This action cannot be undone.
          </p>
        </div>
      </Alert>
    </Dialog>
  );
}


